import { createSelector } from "reselect";

export const DEFAULT_ALERT_DELAYS = { cloudAlert: 300, controllerAlert: 120, noInternet: 900 };

// Basic selectors
const selectConfiguration = (state) => state.configuration || {};

export const getConfiguration = createSelector(
    [selectConfiguration],
    (configuration) => configuration
);

export const getConfigurationValue = (key) =>
    createSelector([selectConfiguration], (configuration) => configuration?.[key]);

const toSeconds = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

// Default alert delays (in seconds) coming from backend configuration,
// falling back to DEFAULT_ALERT_DELAYS when the value is missing/invalid.
export const getDefaultAlertDelays = createSelector(
    [selectConfiguration],
    (configuration) => {
        const delays = configuration?.defaultAlertDelayInSecs;
        return {
            cloudAlert: toSeconds(delays?.cloudAlert, DEFAULT_ALERT_DELAYS.cloudAlert),
            controllerAlert: toSeconds(delays?.controllerAlert, DEFAULT_ALERT_DELAYS.controllerAlert),
            noInternet: toSeconds(delays?.noInternet, DEFAULT_ALERT_DELAYS.noInternet)
        };
    }
);
